export default {
  home: '首页',
  aboutEnterprise: '关于企业',
  contactUs: '联系我们',
  enteringKangyi: '走进康怡',
  introduce: '广东康怡卫生用品有限公司成立于1993年，公司拥有自建高标准工业大厦，配置大型智能化物流中心，总经营面积6.6万平方米，是一家致力打造自主品牌、专业研发、生产卫生巾、婴儿及成人纸尿裤的综合型企业',
  innovation: '创新',
  innovationDescription: '创新永不止步。三十年来，广东康怡作为高新技术企业，注重产品创新和研发，拥有专利36项（含在申请专利）及13个国家级高新技术产品。',
  creatingFuture: '创未来',
  creatingFutureDescription: '在未来的日子里，广东康怡将一如既往地专注于女性、婴幼儿及成人的个人护理用品事业，构建可持续发展的绿色健康产业链，我们将与你携手共创未来。',
  win: '共赢',
  winDescription: '秉承着互助共赢、携手共进的经营理念，我们重视对内部成员的培养，并一直与供应商、经销商共同学习、共同发展。三十年来，广东康怡每年都保持着持续性的增长。',
  coreValues: '核心价值观',
  coreValuesDescription: '诚信缔造未来、关爱创造和谐、革新体现价值、激情成就梦想。',
  companyIntroduce: '企业介绍',
  companyCulture: '企业文化',
  allBrands: '全部品牌',
  hotSale: '热销产品',
  details: '详情',
  informationCenter: '资讯中心',
  companyNews: '企业新闻',
  lifeTips: '生活Tips',
  all: '全部',
  learnMore: '了解更多',
  brandCenter: '品牌中心',
  productDetails: '产品详情',
  brand: '品牌',
  name: '名称',
  code: '货号',
  size: '码数',
  specifications: '规格',
  crowd: '人群',
  allPeople: '所有人',
  baby: '婴儿',
  female: '女性',
  aged: '老年人',
  male: '男性',
  taobaoLink: '淘宝链接',
  jdLink: '京东链接',
  industryIntelligence: '行业情报',
  previousArticle: '上一篇',
  nextArticle: '下一篇',
  articleDetails: '文章详情',
  joinUS: "人才引进",
  franchiseApplication: '加盟申请',
  applicationDescription: '广东康怡三十年来致力于发展卫生用品领域，推出“康怡宝宝”、“亲亲葆葆”、“康护仕”等系列品牌产品已得到广大消费者认可，经过 20多年的积累、沉淀，形成了一条健全良性的产业链。',
  fullName: '姓名',
  pleaseEnterYourName: '请输入您的姓名',
  call: '称呼',
  callTips: '请选择称呼方式',
  sirOrlady: '先生、女士',
  sir: '先生',
  lady: '女士',
  contactNumber: '联系电话',
  pleaseEnterYourContactPhoneNumber: '请输入您的联系电话',
  franchiseRole: '加盟角色',
  distributorOrSupplier: '经销商、供应商',
  distributor: '经销商',
  supplier: '供应商',
  salesArea: '销售地区',
  pleaseEnterYourSalesRegion: '请输入您的销售地区',
  distributionChannel: '销售渠道',
  supermarket: '商超',
  distributionAndDelivery: '经销配送',
  maternalAndChildDelivery: '母婴配送',
  maternalAndChildChain: '母婴连锁',
  onlineRetailers: '电商',
  other: '其他',
  questionsAndRequirements: '问题与要求',
  submit: '提交',
  consumerAndCustomerComplaints: '消费者、客户投诉',
  problemType: '问题类型',
  pleaseSelectTheTypeOfQuestion: '请选择问题类型',
  complaint: '投诉',
  proposal: '建议',
  complaintsOrSuggestions: '投诉或建议',
  complaintsOrSuggestionsDescription: '有什么想对我们说的？我们非常乐意倾听您的声音！',
  company: '广东康怡卫生用品有限公司',
  phone: '电话',
  email: '邮箱',
  address: '地址',
  fax: '传真',
  companyAddress: '广东省佛山市顺德区乐从镇劳村村怡乐路东2号',
  problemTips: '请输入您遇到的问题或建议',
  addressTips: '请选择所在地区',
  submitFranchise: '加盟申请已提交',
  suggestionTips: '感谢您的建议，我们会努力改进的！',
  scan: '扫一扫，更精彩',
  serviceHotline: '服务热线',
  record: '粤公网安备44060602001733号',
  record2: '粤ICP备20061990号-1',
  introduce2013: '2013年，康怡成立二十周年，回顾过去，展望未来，将“打造行业中的百年企业”定位长期发展目标。',
  introduce2014: '2014年，对公司转型升级作出规划部署明确发展方向。',
  introduce2015: '2015年，总部大楼原址改造动工，硬件升级启动。',
  introduce2016: '2016年，引进智能全自动化生产设备并投产。',
  introduce2017: '2017年，公司实行中高管理层“岗位轮换”，康怡团队以“空杯的思想、归零的心态”去迎合新的岗位，激发各管理成员的新思维，管理理念推向新的高度。实行这一举措，康怡在营销、研发、生产、技术等方面都取得了优异的成绩。',
  introduce2018: '2018年，康怡团队凝心聚力，团结一致，正视不足，自我修正，在转型升级的基础上再创新，专注于产品、技术和管理创新，产品竞争力得到进一步的提高；探索并推行康怡经营模式，明确未来5年的发展规划，并顺利通过国家高新技术企业认定。',
  introduce2019: '2019年，康怡团队思想觉悟再提升，对三大系列产品实施“减法”，明确品牌定位，志在变中取胜，使产品更贴近市场需求；康怡人在不同的角色中发挥潜能，从管理迈向经营的革新之路、共同进步、共享价值……',
  introduce2020: '2020年，这一年对于康怡来说是充满机遇和挑战的一年，新冠疫情的突发期，对我们也产生了一定程度的影响，即便如此，康怡仍然慷慨解囊，积极履行社会责任，为湖北捐资赠物，同时全力配合政府复工复产的政策，为企业单位筹集复工复产所需物资。2020年的康怡，可以说是从管理、渠道到品牌，都产生了质的蜕变，不断朝着高质量、高效、创新的方向前进着。',
  introduce2021: '2021年，广东康怡新智能化物流中心投入运营，全新的物流中心采用智能化仓储物流，为成人纸尿裤增产扩量，并为新颖时尚的女性经期裤生产线配备了发展空间。通过智能化的技术提升企业效能，实现仓储物流智能化升级，提高物流配送的效率。我们能够更加专心专注专事，不断精益求精，使企业能够更加快速稳健发展，同时以改革创新推动品牌建设，以品牌助推更高质量发展。',
  introduce2022: '2022年，葆为康成人护理品牌签约影视巨星刘晓庆为品牌形象大使，倡导“保卫健康，葆为康”的品牌理念，保卫中老年人身体健康和心理健康。',
  introduce2023: ' 2023年，全系列智能化生产线配备完毕，总经营面积6.6万平方米。',
  ohDear: '哎呀！',
  allRightsReserved: '保留所有权利',
  tips404: '网站管理员说您无法进入此页面',
  url404: '请检查您输入的URL是否正确，或单击下面的按钮返回首页。',
  backToHome: '回到首页',

  aboutIntroduce: '广东康怡卫生用品有限公司成立于1993年，公司拥有自建高标准工业大厦，配置大型智能化物流中心，总经营面积6.6万平方米，是一家致力打造自主品牌、专业研发、生产卫生巾、婴儿及成人纸尿裤的综合型企业，已通过<国家高新技术企业>、<佛山市细分行业龙头企业>、<佛山市专精特新企业>、<佛山市工程技术研究中心>、<质量管理成熟度3A级企业>认定；三十年来紧跟时代步伐，不断改革创新，拥有行业最先进全智能化生产设备、封闭式洁净空调生产车间，广东康怡将以数智创新推动企业高质量发展。',
  productionStrength: '生产实力',
  productionDescription: '广东康怡拥有20条（进口+国内）全自动化纸尿裤、拉拉裤、成人纸尿裤、卫生巾及护理垫生产线，高标准智能化洁净生产车间。',
  strength1: '3.3万平方米',
  strength1Description: '高标准工业大厦',
  strength2: '3.8万平方米',
  strength2Description: '智能化物流中心',
  strength3: '20条',
  strength3Description: '全自动生产线',
  strength4: '16万片',
  strength4Description: '日产成人纸尿裤',
  strength5: '12万片',
  strength5Description: '日产护理垫',
  strength6: '300万片',
  strength6Description: '日产纸尿裤/拉拉裤',
  innovation: '科研创新',
  innovationDescription: '公司作为高新技术企业，拥有国家专利 60 项（含在申请专利）、7项中国发明专利、15 个国家级高新技术产品。',
  innovationDescription2: '三十年来，我们注重产品研发和技术提升，不断转型升级，钻研新型材料、持续开发新产品，',
  innovationDescription3: '致力于让消费者获得更舒适的使用体验。',
  quality: '质量保证，全球信赖',
  qualityDescription: '我们始终遵循国家/国际质量标准严谨生产，不断融汇专业实践经验，携手社会各界，共筑诚信市场秩序，致力提升产品品质至新高度。',
  authentication: '获得质量管理体系认证 IS045001 认证和 ISO9001 认证',
  standard: '参与制定三项卫生用品团体标准',
  development: '发展之路',
  developmentDescription: '广东康怡成立于1993年，三十多年来年坚持打造自主品牌，以“互助共赢、携手共进”的经验理念，赢得广大合作伙伴的信任。',
  category: '代加工业务品类',
  categoryDescription: '为您提供代加工定制服务',
  business1: '婴儿纸尿裤/拉拉裤加工',
  business2: '成人纸尿裤/尿片/护理垫加工',
  business3: '卫生巾加工',
  business4: '外包装定制',
  business5: '图案定制',
  business6: '产品定制',
  service: '一站式服务 · 让您安心无忧'
}



// WEBPACK FOOTER //
// ./src/lang/zh.js